import { Controller } from "@hotwired/stimulus"

// Miles & More–style FAQ accordion: one panel open at a time by default.
export default class extends Controller {
  static targets = ["item", "trigger", "panel", "iconPlus", "iconClose"]
  static values = { single: { type: Boolean, default: true } }

  toggle(event) {
    const trigger = event.currentTarget
    const item = trigger.closest("[data-faq-accordion-target='item']")
    if (!item) return

    const expanded = trigger.getAttribute("aria-expanded") === "true"

    if (this.singleValue && !expanded) {
      this.itemTargets.forEach((other) => {
        if (other === item) return
        this.#collapseItem(other)
      })
    }

    if (expanded) {
      this.#collapseItem(item)
    } else {
      this.#expandItem(item)
    }
  }

  #expandItem(item) {
    const trigger = item.querySelector("[data-faq-accordion-target='trigger']")
    const panel = item.querySelector("[data-faq-accordion-target='panel']")
    if (!trigger || !panel) return

    trigger.setAttribute("aria-expanded", "true")
    panel.hidden = false
    item.classList.add("landing-faq__item--open")

    const plus = item.querySelector("[data-faq-accordion-target='iconPlus']")
    const close = item.querySelector("[data-faq-accordion-target='iconClose']")
    if (plus) plus.hidden = true
    if (close) close.hidden = false
  }

  #collapseItem(item) {
    const trigger = item.querySelector("[data-faq-accordion-target='trigger']")
    const panel = item.querySelector("[data-faq-accordion-target='panel']")
    if (!trigger || !panel) return

    trigger.setAttribute("aria-expanded", "false")
    panel.hidden = true
    item.classList.remove("landing-faq__item--open")

    const plus = item.querySelector("[data-faq-accordion-target='iconPlus']")
    const close = item.querySelector("[data-faq-accordion-target='iconClose']")
    if (plus) plus.hidden = false
    if (close) close.hidden = true
  }
}
